import {useGetData} from '../../src/apiservice/apiCall'


export function useGetBrand(){
	return useGetData('/api/WebApi/GetBrand')
}
